import React from "react";
import PropTypes from "prop-types";
import { Nav } from "react-bootstrap";

/**
 * Reusable TabbedContainer component that provides a consistent tabbed interface
 * with theme support through CSS variables.
 *
 * @param {Object} props - Component props
 * @param {string} props.activeTab - Current active tab ID
 * @param {Function} props.onTabChange - Callback when tab changes
 * @param {Array} props.tabs - Array of tab configurations
 * @returns {JSX.Element} TabbedContainer component
 */
const TabbedContainer = ({ activeTab, onTabChange, tabs }) => {
  return (
    <div className="tabs-container">
      <Nav
        variant="tabs"
        className="nav-dark"
        style={{ display: "flex", flexDirection: "row", width: "100%" }}
      >
        {tabs.map((tab) => (
          <Nav.Item key={tab.id}>
            <Nav.Link
              active={activeTab === tab.id}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.icon && <i className={`${tab.icon} nav-menu-icon`}></i>}
              {tab.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <div className="tab-content">
        {tabs.map(
          (tab) =>
            activeTab === tab.id && (
              <div
                key={tab.id}
                className="tab-pane fade show active"
                style={{ height: "100%" }}
              >
                {tab.content}
              </div>
            )
        )}
      </div>
    </div>
  );
};

TabbedContainer.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
};

export default TabbedContainer;
